module.exports = __webpack_public_path__ + "static/media/winMusic.8b3074f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/winMusic.mp3
// module id = iVYP
// module chunks = 1